import { useStore } from 'hooks/useStore';
import { useState } from 'react';
import { factScreenServices } from 'services/factsScreenServices';
import { NDCFormFieldsTypes } from 'Interfaces/FactsInterfaces/drugInterfaces';

const useAddModal = ({
  handleNewStrategySelect,
  fieldType,
}: {
  handleNewStrategySelect: (
    option: { code: string; name: string },
    fieldType: NDCFormFieldsTypes
  ) => void;
  fieldType: NDCFormFieldsTypes;
}) => {
  const {
    FactsStore: { toggleAddModalVisibility, handleFetchNdcEditDropDownData },
  } = useStore();
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isAddLoading, setIsAddLoading] = useState(false);
  const [errors, setErrors] = useState<string>('');

  const addMethods = {
    handleAddPPS: async () => {
      try {
        if (!name && !description) {
          setErrors(() => 'Name and Description is required');
          return;
        }
        if (!name) {
          setErrors(() => 'Name is required');
          return;
        } else if (!description) {
          setErrors(() => 'Description is required');
          return;
        }

        setIsAddLoading(true);
        setErrors('');

        await factScreenServices.addNewPPS({
          PricingStrategyDescription: name,
          Notes: description,
        });
        await handleFetchNdcEditDropDownData();
        handleNewStrategySelect({ code: name, name: name }, fieldType);
        toggleAddModalVisibility();
        setName(() => '');
        setDescription(() => '');
        setErrors(() => '');
      } catch (_err) {
        setIsAddLoading(false);
        setErrors(() => `Strategy already exists with name '${name}'`);
      }
    },

    handleAddPPSC: async () => {
      try {
        if (!name && !description) {
          setErrors(() => 'Name and Description is required');
          return;
        }
        if (!name) {
          setErrors(() => 'Name is required');
          return;
        } else if (!description) {
          setErrors(() => 'Description is required');
          return;
        }

        setIsAddLoading(true);
        setErrors('');

        await factScreenServices.addNewPPSSC({
          Reason: name,
          ReasonDescription: description,
        });
        await handleFetchNdcEditDropDownData();
        handleNewStrategySelect({ code: name, name: name }, fieldType);
        toggleAddModalVisibility();
        setName(() => '');
        setDescription(() => '');
        setErrors(() => '');
        if (name !== '' && description !== '') setErrors(() => '');
      } catch (_err) {
        setIsAddLoading(false);
        setErrors(() => `Strategy already exists with name '${name}'`);
      }
    },

    handleAddSegmentation: async () => {
      try {
        if (!name && !description) {
          setErrors(() => 'Name and Description is required');
          return;
        }
        if (!name) {
          setErrors(() => 'Name is required');
          return;
        } else if (!description) {
          setErrors(() => 'Description is required');
          return;
        }

        setIsAddLoading(true);
        setErrors('');

        await factScreenServices.addNewSegmentation({
          ReportingSegmentTypeID: '2',
          ReportingSegmentName: name,
          Notes: description,
        });
        await handleFetchNdcEditDropDownData();
        handleNewStrategySelect({ code: name, name: name }, fieldType);
        toggleAddModalVisibility();
        setName(() => '');
        setDescription(() => '');
        setErrors(() => '');
      } catch (_err) {
        setIsAddLoading(false);
        setErrors(() => `Strategy already exists with name '${name}'`);
      }
    },

    handleAddDPStrategy: async () => {
      try {
        if (!name && !description) {
          setErrors(() => 'Name and Description is required');
          return;
        }
        if (!name) {
          setErrors(() => 'Name is required');
          return;
        } else if (!description) {
          setErrors(() => 'Description is required');
          return;
        }

        setIsAddLoading(true);
        setErrors('');

        await factScreenServices.addNewSegmentation({
          ReportingSegmentTypeID: '7',
          ReportingSegmentName: name,
          Notes: description,
        });
        await handleFetchNdcEditDropDownData();
        handleNewStrategySelect({ code: name, name: name }, fieldType);
        toggleAddModalVisibility();
        setName(() => '');
        setDescription(() => '');
        setErrors(() => '');
      } catch (_err) {
        setIsAddLoading(false);
        setErrors(() => `Strategy already exists with name '${name}'`);
      }
    },
  };

  return {
    name,
    setName,
    description,
    setDescription,
    addMethods,
    isAddLoading,
    errors,
    setErrors,
  };
};

export default useAddModal;
